// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"0dff75bf","567":"94da72e0","625":"94da72e0","644":"2cc9e58a"}[chunkId] + ".chunk.css";
};